// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerLinks":"Footer_footerLinks__3aiFY","footerLink":"Footer_footerLink__zoJJ6","footerSep":"Footer_footerSep__kn8nd"};